<app-header>
  <div class="first-section"></div>
</app-header>

<div class="second-section">
  <div class="registration-card">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">{{ SalaryDividendFormContentResources["get-started.body.title"] | render | async }}</h2>

              <p class="card-text text-start">{{ SalaryDividendFormContentResources["get-started.body.subtitle"] | render | async }}</p>

              <div id="salary_dividend_hubspot_form"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>